/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { OpaqueToken } from '@angular/core';
/**
 * A DI Token representing the main rendering context. In a browser this is the DOM Document.
 *
 * Note: Document might not be available in the Application Context when Application and Rendering
 * Contexts are not the same (e.g. when running the application into a Web Worker).
 *
 * @stable
 */
export var /** @type {?} */ DOCUMENT = new OpaqueToken('DocumentToken');
//# sourceMappingURL=dom_tokens.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/platform-browser/src/dom/dom_tokens.js
// module id = 178
// module chunks = 10